import { render, staticRenderFns } from "./DependantShort.vue?vue&type=template&id=713a7ac3"
import script from "./DependantShort.vue?vue&type=script&lang=js"
export * from "./DependantShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports